import React, { ReactNode, useState, useEffect } from "react";
import Modal from "react-modal";

import "./customModal.scss";

interface CustomModalProps {
  headerContent?: ReactNode; // puede ser un string o un componente JSX
  bodyContent?: ReactNode; // puede ser un string o un componente JSX
  isOpen: boolean; // Determina si el modal está abierto o cerrado
  onRequestClose?: () => void; // Función para manejar el cierre del modal
}

const CustomModal: React.FC<CustomModalProps> = ({
  headerContent,
  bodyContent,
  isOpen,
  onRequestClose,
}) => {
  Modal.setAppElement("#root");

  const [modalIsOpen, setModalIsOpen] = useState(isOpen);

  useEffect(() => {
    setModalIsOpen(isOpen);
  }, [isOpen]);

  const closeModal = (type: string) => {
    if (!type) {
      if (onRequestClose) {
        onRequestClose();
      } else {
        setModalIsOpen(false);
      }
    } else {
      setModalIsOpen(false);
    }
  };

  const handleRequestClose = () => {
    setModalIsOpen(false);
  };

  (window as any).bullseyeCustomModalOpen = () => setModalIsOpen(true);
  (window as any).bullseyeCustomModalClose = () => setModalIsOpen(false);

  return (
    <div className="bullseye_modal">
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={handleRequestClose} // Use internal handleRequestClose function
        style={{
          content: {
            ...(window as any).bullseyeLocationsConfig?.customModal?.style
              ?.content,
          },
        }}
        onAfterOpen={
          (window as any).bullseyeLocationsConfig?.customModal?.onAfterOpen
        }
      >
        <div className="modal-header bullseye_custom_modal_header">
          {headerContent ?? (
            <div
              className="bullseye_custom_modal_header_children"
              dangerouslySetInnerHTML={{
                __html: (window as any).bullseyeLocationsConfig?.customModal
                  ?.header,
              }}
            ></div>
          )}
          <button
            type="button"
            className="btn-close"
            onClick={() => closeModal("handlerButton")}
          />
        </div>
        <div className="modal-body bullseye_custom_modal_body">
          {bodyContent ?? (
            <div
              className="bullseye_custom_modal_body_children"
              dangerouslySetInnerHTML={{
                __html: (window as any).bullseyeLocationsConfig?.customModal
                  ?.body,
              }}
            />
          )}
        </div>
      </Modal>
    </div>
  );
};

export default CustomModal;
